// Status color mapping utility
export const getStatusColor = (status: string) => {
  const colors: Record<string, string> = {
    'CRIAR': 'default',
    'CONFERIR': 'primary',
    'VERIFICAÇÃO PENDENTE': 'warning',
    'VERIFICAÇÃO ENVIADA': 'info',
    'VERIFICAÇÃO APROVADA': 'success',
    'VERIFICAÇÃO REJEITADA': 'error',
    'REJEITADO PELA EQUIPE': 'error',
    'DUPLICADA': 'error',
    'ATIVA EM ÉVORA': 'info',
    'EM TRANSFERÊNCIA': 'info',
    'ACEITAR CONVITE': 'info',
    'ENVIAR CDC': 'info',
    'ALTERAR P/BIKE': 'info',
    'CONFERIR SE ALTEROU P/BIKE': 'info',
    'ENTREGAR': 'warning',
    'ATIVA': 'success',
    'DOCUMENTOS REJEITADOS': 'error',
    'DOCUMENTOS EXPIRADOS': 'error',
    'SEM RESPOSTA': 'warning',
    'BLOQUEADA': 'error',
    'BANIDA': 'error',
  };
  return colors[status] || 'default';
};

// File operations utilities
export const downloadFile = async (filename: string, displayName: string) => {
  try {
    const proxyUrl = `${process.env.REACT_APP_API_URL || 'http://localhost:5000/api'}/files/${filename}`;
    const response = await fetch(proxyUrl);
    const blob = await response.blob();
    
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = displayName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};

export const getFilePreviewUrl = (filename: string) => {
  return `${process.env.REACT_APP_API_URL || 'http://localhost:5000/api'}/files/${filename}`;
};

export const copyToClipboard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    console.log('Text copied to clipboard:', text);
  } catch (err) {
    console.error('Failed to copy text:', err);
  }
};

// File type detection
export const getFileType = (filename: string): 'image' | 'pdf' => {
  const ext = filename.toLowerCase().split('.').pop();
  return ext === 'pdf' ? 'pdf' : 'image';
}; 